<template>
  <div :id="questionId" class="questionModel">
    <b-col>
      <b-row class="mx-0">
        <b-form-checkbox
          v-model="value"
          :name="name"
          unchecked-value="No"
          value="Yes"
          @input="changeItem($event)"
        />
        {{ label }}
      </b-row>
      <span v-show="helpText" class="helpTextStyle" v-html="helpText"></span>
    </b-col>
  </div>
</template>

<script>
  export default {
    name: 'Checkbox',
    props: ['label', 'name', 'answer', 'helpText', 'questionId'],
    data() {
      return {
        value: '',
      };
    },
    computed: {
      answerId() {
        return this.answer === undefined ? undefined : this.answer[0]['Id'];
      },
    },
    created() {
      if (this.answer !== undefined) {
        this.value = this.answer[0]['Saved_Value__c'];
        this.changeItem(this.value);
      } else {
        this.value = '';
      }
    },
    methods: {
      changeItem(event) {
        this.$emit('input', { value: event, id: this.answerId });
      },
    },
  };
</script>
